import { useEffect } from 'react';

const useWistiaScript = () => {
  useEffect(() => {
    const WISTIA_MAIN_SCRIPT_ID = 'wistia-player-script';

    if (!document.querySelector(`#${WISTIA_MAIN_SCRIPT_ID}`)) {
      const wistiaScript = document.createElement('script');
      wistiaScript.id = WISTIA_MAIN_SCRIPT_ID;
      wistiaScript.type = 'text/javascript';
      wistiaScript.src = '//fast.wistia.net/assets/external/iframe-api-v1.js';
      wistiaScript.async = true;
      document.head.appendChild(wistiaScript);
    }

    return () => {
      // Cleanup if necessary
    };
  }, []);
};

export default useWistiaScript;
